<template>
  <view class="city-main">
    {{ info.city_name }}
    <view class="address_bottom" wx:if="{{info.city_code_gp}}">
      {{ info.city_code_gp }} {{ info.is_cn ? '' : info.country_name_cn }}
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  props: {
    info: Object
  },
  methods: {}
})
</script>

<style scoped lang="stylus" >
.city-main
  display flex
.address_bottom
  background #fff
  color #999999
  font-size 14px
  margin-left 7px</style>
<script name='json'>
module.exports = {
  component: true,
  usingComponents: {
  }
}
</script>
